import DebugConsole from '../../../../debug/debug-console';

/**
 * The logging wrapper for the console.
 * @type {Object}
 */
export const logger = new DebugConsole();



// WEBPACK FOOTER //
// ./Library/1.0/common/tracking/pwa-adapter/pwa-core/helpers/index.js